import styled from '@emotion/styled';
import { ComponentProps } from 'react';
import { Css, Responsive } from '../../../../../../ui';

export const Column = styled.div`
	flex: 1;
	padding-right: ${Css.pxToRem(24)};
	padding-top: ${Css.pxToRem(8)};
	padding-bottom: ${Css.pxToRem(8)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		padding-right: ${Css.pxToRem(16)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-top: 0px;
		padding-bottom: 0px;
	}

	&:last-of-type {
		padding-right: 0;
	}
`;

export function BaseCell(props: ComponentProps<typeof Column>) {
	return <Column role="cell" {...props} />;
}

export function BaseHeader(props: ComponentProps<typeof Column>) {
	return <Column role="columnheader" {...props} />;
}
